import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

interface InfoAccordionSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export const InfoAccordionSection = ({
  title,
  isExpanded,
  onToggle,
  children,
  className,
  contentClassName,
}: InfoAccordionSectionProps) => {
  return (
    <section
      className={cn(
        "overflow-hidden rounded-xl border border-border bg-card shadow-sm",
        className
      )}
    >
      <button
        type="button"
        onClick={onToggle}
        className={cn(
          "flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-muted/40",
          isExpanded && "border-b border-border/60"
        )}
      >
        <span className="z-body-md text-foreground">{title}</span>
        <ChevronDown
          className={cn(
            "h-4 w-4 shrink-0 text-muted-foreground transition-transform",
            isExpanded && "rotate-180"
          )}
        />
      </button>
      {isExpanded ? (
        <div className={cn("px-4 py-3.5", contentClassName)}>{children}</div>
      ) : null}
    </section>
  );
};
